import api from './api'
import type { Location } from '../types'

export const zoneApi = {
  getLocations: (siteId: string) => api.get<Location[]>(`/sites/${siteId}/locations`).then((r) => r.data),
  getLocation: (siteId: string, id: string) => api.get<Location>(`/sites/${siteId}/locations/${id}`).then((r) => r.data),
  createLocation: (siteId: string, data: Partial<Location>) => api.post<Location>(`/sites/${siteId}/locations`, data).then((r) => r.data),
  updateLocation: (siteId: string, id: string, data: Partial<Location>) => api.patch<Location>(`/sites/${siteId}/locations/${id}`, data).then((r) => r.data),
  deleteLocation: (siteId: string, id: string) => api.delete(`/sites/${siteId}/locations/${id}`),
}
